import { hiddenSearchColumnStyles } from 'theme'

export const gridSxProps = theme => ({
  // Base background color for the grid
  '--background-color': theme.palette.background.paper,
  '--aggregation-row-background': theme.palette.background.paper,

  '& .MuiDataGrid-row.product-row .MuiDataGrid-cell[data-field="__check__"] .MuiCheckbox-root svg': {
    borderColor: theme.palette.text.disabled,
  },
  '& .MuiDataGrid-cell[data-field="orgNameReference"]': {
    width: 1,
    display: 'none',
  },
  '& .MuiDataGrid-columnHeader[data-field="orgNameReference"]': {
    width: 1,
    display: 'none',
  },
  '& .MuiDataGrid-row.product-row .MuiDataGrid-cellCheckbox': {
    '--disabled-checkbox-background': theme.palette.background.gradientDefault,
  },

  // Aggregation row styling - fix transparent background on horizontal scroll
  '& .MuiDataGrid-row[data-id="auto-generated-group-footer-root"]': {
    backgroundColor: `${theme.palette.background.paper} !important`,
  },
  '& .MuiDataGrid-row[data-id="auto-generated-group-footer-root"] .MuiDataGrid-cell': {
    backgroundColor: 'inherit !important',
  },

  // Pinned columns background - prevent color mismatch on scroll
  '& .MuiDataGrid-pinnedColumns--left, & .MuiDataGrid-pinnedColumns--right': {
    backgroundColor: theme.palette.background.paper,
  },
  ...hiddenSearchColumnStyles,
  // Pinned colors as CSS vars
  '--pinned-base': theme.palette.background.input, // base bg for pinned area
  '--pinned-hover': theme.palette.background.section, // hover bg for pinned rows
  // '--parent-org-background': theme.palette.background.default,
  // '--parent-org-hover': theme.palette.background.section, // optional hover color
  // '--parent-org-selected': theme.palette.background.input, // optional selected color
  // '& .MuiDataGrid-row.parent-org-row': {
  //   backgroundColor: 'var(--parent-org-background) !important',
  // },
  // '& .MuiDataGrid-row.parent-org-row:hover, & .MuiDataGrid-row.parent-org-row.Mui-hovered': {
  //   backgroundColor: 'var(--parent-org-hover) !important',
  // },
  // '& .MuiDataGrid-row.parent-org-row.Mui-selected, & .MuiDataGrid-row.parent-org-row.Mui-selected:hover': {
  //   backgroundColor: 'var(--parent-org-selected) !important',
  // },
  // '& .MuiDataGrid-row.parent-org-row .MuiDataGrid-cell': {
  //   backgroundColor: 'transparent !important',
  // },
  // 1) Pin container: set base + override MUI's row hover var locally
  '& .MuiDataGrid-pinnedRows--top': {
    backgroundColor: 'var(--pinned-base)',
    '--DataGrid-rowHoverBackground': 'var(--pinned-hover)',
    overflowY: 'auto',
  },
  // '& .MuiDataGrid-cell--textLeft': {
  //   boxShadow: `0 1px 0 0 ${theme.palette.text.disabled}`,
  // },
  // 2) Pinned rows: set base + transition
  '& .MuiDataGrid-pinnedRows--top .MuiDataGrid-row': {
    backgroundColor: 'var(--pinned-base)',
    transition: 'background-color 180ms ease',
  },

  // 3) Pinned row hover: single source of truth (beats any “inherit”)
  '& .MuiDataGrid-pinnedRows--top .MuiDataGrid-row:hover, \
     & .MuiDataGrid-pinnedRows--top .MuiDataGrid-row.Mui-hovered': {
    backgroundColor: 'var(--pinned-hover) !important',
  },

  // 4) Selected + hover in pinned area (avoid second color)
  '& .MuiDataGrid-pinnedRows--top .MuiDataGrid-row.Mui-selected, \
     & .MuiDataGrid-pinnedRows--top .MuiDataGrid-row.Mui-selected:hover': {
    backgroundColor: 'var(--pinned-hover) !important',
  },

  // 5) Cells shouldn’t paint over the row bg
  '& .MuiDataGrid-pinnedRows--top .MuiDataGrid-row:hover .MuiDataGrid-cell': {
    backgroundColor: 'transparent !important',
  },

  // 6) Disable the cell hover transform in pinned area to prevent flicker
  '& .MuiDataGrid-pinnedRows--top .MuiDataGrid-cell:hover': {
    transform: 'none !important',
    boxShadow: 'none !important',
  },

  // A11y: reduce motion
  '@media (prefers-reduced-motion: reduce)': {
    '& .MuiDataGrid-pinnedRows--top .MuiDataGrid-row': {
      transition: 'none',
    },
  },
  '& .MuiDataGrid-filler--pinnedLeft': {
    width: '0px !important',
    display: 'none !important',
  },
})
